import { ProductIDType, ResultObjectType } from '@cbgms/api/modules/enums'
import { IGetProductsBySearchAttributesParams, IProductIdentifier } from '.'
import { HttpMethod } from '../../http-method'
import { VPOMOrderManagementQueryOptions } from 'modules/enums/vpom_order_management_query_options'

export const getProductGroups = (vehicleUUID?: string, orderAccountUUID?: string) => ({
  method: 'GET',
  url: '/modules/product-groups',
  params: {
    VehicleUUID: vehicleUUID,
    OrderAccountUUID: orderAccountUUID
  }
})
export const getHaynesproReqQty = (vehicleUUID?: string) => ({
  method: 'GET',
  url: `/modules/vehicles/${vehicleUUID}/haynespro/required-quantity`
})
export const getProductGroupsSearch = (vehicleUUID?: string, orderAccountUUID?: string, searchTerm?: string) => ({
  method: 'GET',
  url: '/modules/product-groups-search',
  params: {
    VehicleUUID: vehicleUUID,
    OrderAccountUUID: orderAccountUUID,
    SearchTerm: searchTerm || ''
  }
})

export const getProductGroupsOrdersSearch = (
  orderAccountUUID?: string,
  query?: string,
  resultTypes?: ResultObjectType[],
  vehicleUUID?: string
) => ({
  method: 'GET',
  url: '/modules/product-groups/orders/search',
  params: {
    OrderAccountUUID: orderAccountUUID,
    Query: query,
    ResultTypes: resultTypes,
    VehicleUUID: vehicleUUID
  }
})

export const getProductGroupSearchAttributes = (productGroupUUID: string, orderAccountUUID?: string) => ({
  method: 'GET',
  url: `/modules/product-groups/${productGroupUUID}/filter-attributes`,
  params: {
    OrderAccountUUID: orderAccountUUID
  }
})

export const getPopularProductGroupSearchAttributes = (productGroupUUID: string, orderAccountUUID?: string) => ({
  method: HttpMethod.GET,
  url: `/modules/product-groups/${productGroupUUID}/popular-filter-attributes`,
  params: {
    OrderAccountUUID: orderAccountUUID
  }
})

export const getProduct = (supplierID: string, idType: ProductIDType, orderAccountUUID: string, optionalVehicleUUID?: string) => ({
  method: 'GET',
  url: `/modules/products/by-supplier-product-id/${encodeURIComponent(supplierID)}`,
  params: { IDType: idType, OrderAccountUUID: orderAccountUUID, VehicleUUID: optionalVehicleUUID }
})

export const getProducts = (productGroup: string, vehicleUUID: string, orderAccountUUID: string) => ({
  method: 'GET',
  url: `/modules/products/product-group/${productGroup}?VehicleUUID=${vehicleUUID}${
    orderAccountUUID && `&OrderAccountUUID=${orderAccountUUID}`
  }`
})

export const getProductsBySearchAttributes = (data: IGetProductsBySearchAttributesParams) => ({
  method: 'POST',
  url: `/modules/products/product-group/${data.ProductGroup}/by-attributes`,
  data
})

export const searchProducts = (orderAccountUUID: string, searchTerm: string, excludeAvailability: boolean, QueryOptions?: string) => ({
  method: 'GET',
  url: '/modules/products/by-searchterm',
  params: {
    Searchterm: searchTerm,
    ...(orderAccountUUID ? { OrderAccountUUID: orderAccountUUID, ExcludeAvailability: String(excludeAvailability) } : {}),
    ...(QueryOptions ? { QueryOptions } : {})
  }
})

// FetchAdapter encodes params with URLSearchParams, which natively percent-encodes
// special characters such as '+', ',' and '.' without manual handling.
export const searchRMAProducts = (orderAccountUUID: string, searchTerm: string, excludeAvailability: boolean, QueryOptions?: string) => ({
  method: 'GET',
  url: '/modules/rma/by-searchterm',
  params: {
    Searchterm: searchTerm,
    ...(orderAccountUUID ? { OrderAccountUUID: orderAccountUUID, ExcludeAvailability: String(excludeAvailability) } : {}),
    ...(QueryOptions ? { QueryOptions } : {})
  }
})

export const getGenericProducts = (
  genericArticlesID: string,
  vehicleUUID: string,
  orderAccountUUID: string,
  excludeAvailability: boolean
) => ({
  method: 'GET',
  url: `/modules/products/by-generic-articles?GenericArticles=${genericArticlesID}&VehicleUUID=${vehicleUUID}${
    orderAccountUUID && `&OrderAccountUUID=${orderAccountUUID}&ExcludeAvailability=${excludeAvailability}`
  }`
})

export const getProductsByWorkorder = (orderAccountUUID: string, workorderUUID: string) => ({
  method: 'GET',
  url: `/modules/products/by-workorder/${workorderUUID}?OrderAccountUUID=${orderAccountUUID}`
})

export const getProductAvailability = (
  OrderAccountUUID: string,
  ProductIDs: IProductIdentifier[],
  QueryOptions?: VPOMOrderManagementQueryOptions
) => ({
  method: 'POST',
  url: '/modules/products/availabilities/by-ids',
  data: {
    OrderAccountUUID,
    ProductIDs,
    QueryOptions
  }
})

export const getProductVehicleCompatibilityByProductID = (
  id: string,
  idType: string,
  productGroupId: string,
  orderAccountUUID: string,
  optionalVehicleUUID?: string
) => ({
  method: 'GET',
  url: `/modules/products/vehicle-compatibility`,
  params: {
    ID: id,
    IDType: idType,
    ProductGroupID: productGroupId,
    OrderAccountUUID: orderAccountUUID,
    OptionalVehicleUUID: optionalVehicleUUID
  }
})

export const getProductRelationsByProductID = (id: string, idType: string, orderAccountUUID: string, optionalVehicleUUID?: string) => ({
  method: 'GET',
  url: `/modules/products/product-relations`,
  params: { ID: id, IDType: idType, OrderAccountUUID: orderAccountUUID, OptionalVehicleUUID: optionalVehicleUUID }
})

export const getRefurbishmentFormTemplates = (wholesalerUUID: string) => ({
  method: 'GET',
  url: `/modules/refurbishment/form_templates/wholesaler/${wholesalerUUID}/forms`
})

export const getFormJSON = (wholesalerUUID: string, formUUID: string) => ({
  method: 'GET',
  url: `/modules/refurbishment/wholesalers/${wholesalerUUID}/forms/${formUUID}`
})
export const postRefurbishmentForm = (wholesalerUUID: string, formUUID: string, data: any) => ({
  method: 'POST',
  url: `/modules/refurbishment/wholesalers/${wholesalerUUID}/forms/${formUUID}`,
  data
})

export const getVehicleTyreSuggestion = (
  id: string,
  idType: ProductIDType,
  orderAccountUUID: string,
  vehicleUUID: string,
  vehicleLinkageCriteria: any[]
) => ({
  method: 'POST',
  url: `/modules/products/vehicle-tyresuggestion`,
  params: {
    ID: id,
    IDType: idType,
    OrderAccountUUID: orderAccountUUID,
    VehicleUUID: vehicleUUID
  },
  data: {
    vehicleLinkageCriteria
  }
})
